module.exports = __webpack_public_path__ + "img/meaning_and_purpose.c034b46d.png";